export enum seatColorEnum {
  AVAILABLE = "seatColors.available",
  SELECTED = "seatColors.selected",
  BOOKED = "seatColors.booked",
  SOLD = "seatColors.sold",
  HOLD = "seatColors.hold",
  "ROW LABEL" = "seatColors.row_label",
}
